
export default function () {
    const maxHeight = 370; 
    return {
        expanded: false,
        expandable: true,
        init() {
            const col = this.$refs.col;
            const original = this.$refs.original;

            if (original.offsetHeight > maxHeight) {
                this.shrink();
            } else {
                this.expandable = false
            }
        },
        expand() {
            const col = this.$refs.col;

            col.style.maxHeight = this.$refs.original.offsetHeight + 'px';
            this.expanded = true;
            if (col.classList.contains('collapsed')) {
                col.classList.remove('collapsed');
            }
        },
        shrink() {
            const col = this.$refs.col;

            col.style.maxHeight = maxHeight + 'px';
            this.expanded = false;
            
            if (!col.classList.contains('collapsed')) {
                col.classList.add('collapsed');
            }
        },
        toggle() {
            if (this.expanded) {
                this.shrink();
            } else {
                this.expand();
            }
        },
        expandButton: {
            ['x-show']() {
                return this.expandable && !this.expanded
            },
            ['x-on:click'] () {
                return this.toggle
            }
        },
        shrinkButton: {
            ['x-show']() {
                return this.expandable && this.expanded
            }
        }
    }
}